import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const SENT = 'sent'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [SENT]: {
      label: `Sent`,
      name: SENT,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SENT]: false,
}


export default formModel
